<!--全年碳排放指标（柱状图，环形图，数字卡片）-->
<template>
<div class="ce commonborder flex_row">
  <div id="ce_bar1" class="echarts"></div>



  <div class="right flex_column">
    <div class="top flex_row">
      <div class="left flex_column">
        <div class="title">全年降低碳排放(kg)</div>
        <div class="numberbox">
          <span v-for="(item,index) in total" :key="index">{{item}}</span>
        </div>
      </div>
      <div id="ce_pie2" class="echarts"></div>
    </div>
    <div id="ce_pie1" class="echarts"></div>
  </div>
</div>

</template>

<script>
import api from '@/apis/power/power';
let echarts = require("echarts/lib/echarts");
export default {
  data() {
    return {
      total:'',
    };
  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  methods: {
    //获取数据
    getList(){
      api.getCarbon().then(res=>{
        if(res.code==10000){
          let _data = res.data.list[0]
          let _total = _data.carbonEmission.toString()
          this.total = _total.split('')
          let _zhibiao = [_data.carbonTarger,_data.dioxideTarget,_data.sulfurTargert,_data.nitrogenTarget]
          let _last = [_data.carbonDataLast,_data.dioxideDataLast,_data.sulfurDataLast,_data.nitrogenDataLast]
          let _this = [_data.carbonData,_data.dioxideData,_data.sulfurData,_data.nitrogenData]
          this.ce_bar1(_zhibiao,_last,_this)
          this.ce_pie1(
            _data.proReduct,
            _data.greenReduct,
            _data.workReduct,
            _data.staffReduct,
            _data.trafficReduct,
            _data.buildingReduct,
          )
          this.ce_pie2(_data.disStandard)
        }
      })
    },
    ce_bar1(a,b,c){
      let ce_bar1 = echarts.init( document.getElementById('ce_bar1') );
      ce_bar1.setOption({
          color:['#1a02e5','#00f2fe','#f5c74f','#d9001b'],
          tooltip: { 
            trigger: 'axis',
            textStyle:{
              fontSize: this.$echartsFontSize
            },
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
              data: ['指标','去年', '今年'],
              left: 15, top:8,
              textStyle: {
                  color: this.legendTextColor,fontSize:this.$echartsFontSize
              },
              itemWidth: this.$echartsFontSize,
              itemHeight: this.$echartsFontSize/3,
          },
          xAxis: {
              type: 'category',
              axisLabel:{textStyle:{color:this.axisLabelColor,fontSize:this.$echartsFontSize}},
              axisLine:{lineStyle:{color:this.axisLineColor}},
              axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
              data: ['碳粉层/T', '二氧化碳/T', '二氧化硫/T', '氮氧化物/T']
          },
          yAxis: {
              axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
              axisLine:{lineStyle:{color:this.axisLineColor}},
              splitNumber:3,
              splitLine:{show:true,lineStyle:this.splitLineStyle},
          },
          grid: { left: '4%',right:'4%',top:'22%',bottom:'4%',containLabel: true},
          series: [
              {
                name:'指标',
                type: 'bar',
                barWidth: '11%',
                data: a,
                // itemStyle:{
                //   barBorderRadius : [ 12, 12, 0, 0],
                //   color: new echarts.graphic.LinearGradient(
                //     0, 1, 0, 0, [{
                //         offset: 0,
                //         color: '#1b02f357'
                //       },
                //       {
                //         offset: 1,
                //         color: '#1b02f3'
                //       }
                //     ]
                //   )
                // }
              },
              {
                name:'去年',
                type: 'bar',
                barWidth: '12%',
                data: b,
                // itemStyle:{
                //   barBorderRadius : [ 12, 12, 0, 0],
                //   color: new echarts.graphic.LinearGradient(
                //     0, 1, 0, 0, [{
                //         offset: 0,
                //         color: '#79f5f757'
                //       },
                //       {
                //         offset: 1,
                //         color: '#79f5f7'
                //       }
                //     ]
                //   )
                // }
              },
              {
                name:'今年',
                type: 'bar',
                barWidth: '12%',
                data: c,
                // itemStyle:{
                //   barBorderRadius : [ 12, 12, 0, 0],
                //   color: new echarts.graphic.LinearGradient(
                //     0, 1, 0, 0, [{
                //         offset: 0,
                //         color: '#3dfeb057'
                //       },
                //       {
                //         offset: 1,
                //         color: '#3dfeb0'
                //       }
                //     ]
                //   )
                // }
              } 
          ]
      })
      this.$common.moveEcharts(4,ce_bar1);
   },
    ce_pie1(c1,c2,c3,c4,c5,c6){
      let ce_pie1 = echarts.init( document.getElementById('ce_pie1') );
      ce_pie1.setOption({
          color:['#00ccff','#1ad38b','#fc5976','#ae74f3','#f4af1b'],
          tooltip: {
              trigger: 'item',textStyle:{fontSize: this.$echartsFontSize},
          },
          legend: {
              show:false
          },
          series: [
              {
                  type: 'pie',
                  radius: ['30%', '50%'],
                  center:['50%','50%'],
                  top:'2%',

                  avoidLabelOverlap: true,
                  itemStyle: {
                      borderRadius: 4,
                      borderColor: '#081693',
                      borderWidth: 2
                  },
                  label: {
                      show: true,color:'#ccd0f2',fontSize:this.$echartsFontSize-2,
                      formatter: '{b}\n{num|{d}%}', lineHeight:this.$echartsFontSize+4,
                      rich: {
                          num: {
                              color: '#fff',fontSize:this.$echartsFontSize
                          }
                      }
                  },
                  data: [
                      {value: c1, name: '生产降碳'},
                      {value: c2, name: '绿化降碳'},
                      {value: c3, name: '办公降碳'},
                      {value: c4, name: '员工降碳'},
                      {value: c5, name: '交通降碳'},
                      {value: c6, name: '楼宇降碳'}
                  ]
              }
          ] 
      })
    },
    ce_pie2(s1){
      let ce_pie2 = echarts.init( document.getElementById('ce_pie2') );
      ce_pie2.setOption({
          color:['#24ffb1','#3d4dae'],
          title: [{
              text: '达标率',
              x: 'center',
              // top: '55%',
              bottom:'10%',
              textStyle: {
                  color: '#ccd0f2',
                  fontSize:this.$echartsFontSize-2,
                  fontWeight: '100',
              }
          }, {
              text: s1+'%',
              x: 'center',
              top: '32%',
              textStyle: {
                  fontSize:this.$echartsFontSize,
                  color: '#fff',
                  fontWeight: '600',
              },
          }],
          polar: {
              radius: ['80%', '85%'],
              center: ['50%', '50%'],
          },
          angleAxis: {
              max: 100,
              show: false,
          },
          radiusAxis: {
              type: 'category',
          },
          series: [
              {
                  type: 'bar',
                  roundCap: true,
                  barWidth: 60,
                  showBackground: true,
                  backgroundStyle: {
                      color: 'rgba(255, 255, 255, .2)',
                  },
                  data: [s1],
                  coordinateSystem: 'polar'
              }
          ] 
      })
    },
  },
  mounted() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.ce{
  #ce_bar1{ height: 100%; width: 100%;}
  &>.right{ 
    display: none;
    width: 50%; height: 90%; margin:10px; background: rgba(3,15,97,.2); border: #555e86 dashed 1px; border-radius: 6px;
    &>.top{ width:100%; height: 30%; 
    // display: none;
      &>.left{ width: 70%;
       height: 100%; text-align: center; align-items: center; justify-content: center;
        .numberbox{ text-align: center;
          span{ display: inline-block; background: rgba(0,0,0,.1); box-shadow: 0 0 5px rgba(0,188,255,.8) inset;
            border-radius: 5px; overflow: hidden; font-family: 'DS-DIGI'; font-size: 1.2rem; margin: 2px; color: #fff; font-weight: normal;
            border:1px solid transparent; width: 1.1rem; height: 1.6rem; line-height: 1.6rem; text-align: center;
            background-clip:padding-box,border-box;
            background-origin:padding-box,border-box;
            background-image:linear-gradient(#0720a0,#0720a0),linear-gradient(#0720a0,#00bcff);
          }
        }
      }
      #ce_pie2{ width: 30%; height: 100%;}
    }
    #ce_pie1{ width:100%; height: 100%;}
  }
}



</style>